import { UpdateInfoDto } from '@jobindsats/typescript-fetch-jobindsats';
import { LitElement, html, css } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { JobindsatsElement } from '../core/jobindsats-element';

@customElement('maaling-accordion-element')
export class MaalingAccordionElement extends JobindsatsElement(LitElement) {
    static styles = css`
        .accordion-button {
            background-color: #0000;
            text-align: left;
            border: none;
            padding: 0px;
            word-break: break-word;
        }
        @media only screen and (max-width: 1200px) {
            .subtext-container {
                flex-direction: column;
            }
            .subtext-container > span {
                margin-bottom: 5px;
            }
            .accordion-button {
                margin: 10px 0px;
            }
        }
        .accordion-heading {
            padding: 0px 30px;
            word-break: break-word;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid var(--divider-color-closed);
            color: var(--main-blue);
        }
         .accordion-heading[aria-expanded="true"] {
              border-bottom: 0;
        }
        .accordion-heading button {
            color: var(--main-blue);
        }
        .accordion-content {
            padding: 30px;
            background-color: var(--main-zebra);
            border-bottom: 0;
        }
        .maaling-link {
            flex-shrink: 0;
            margin: 0 0 0px;
        }
        .header-content-group {
            margin: 0 0 15px 0;
        }
        .margin-auto {
            margin: auto;
        }
        .subtext-container {
            display: flex;
            color: var(--font-color);
            margin-top: 5px;
            margin-bottom: 7px;
            align-items: baseline;
        }
        .subtext-container > * {
            margin-right: 12px;
        }
        .more-info {
            margin-top: 0px;
        }
        .no-bottom-margin {
              margin-block-end: 0;
        }

        @media only screen and (max-width: 550px) {
            .accordion-heading {
                flex-direction: column;
                align-items: flex-start;
                padding-bottom: 24px;
            }
            .subtext-container {
                margin-bottom: 0;
            }
        }
        `;

    static instance = 0;

    @property()
    title = '';

    @property({
        attribute: 'maaling-url'
    })
    maalingUrl = '';

    @property({
        attribute: 'heading-level',
    })
    headingLevel = "1";

    @property()
    updateInfo?: UpdateInfoDto;

    
    @property({
        attribute: 'id',
    })
    id = ++MaalingAccordionElement.instance + 'lit-accordion';

    @state()
    expanded = false;

    constructor() {
        super();
    }

    connectedCallback() {
        super.connectedCallback();
    }

    render() {
        return html`
            <div class="accordion-heading" aria-expanded="${this.expanded}">
                <div class="header-content-group">
                    <div class="h${this.headingLevel}" role="heading" aria-level="${this.headingLevel}">
                        <a href="${this.maalingUrl}">
                            ${this.title}
                        </a>
                    </div>
                    <div class="subtext-container">
                        <span>Opdateret: ${this.updateInfo?.lastUpdate ? this.updateInfo.lastUpdate.toLocaleDateString('da-DK', {year:"numeric", month:"short", day:"numeric"})  : ''}</span>
                        <span>Næste opdatering: ${this.updateInfo?.nextUpdate ? this.updateInfo.nextUpdate.toLocaleDateString('da-DK', {year:"numeric", month:"short", day:"numeric"})  : ''}</span>
                        <button @click=${this.toggleAccordion} class="accordion-button" aria-expanded="${this.expanded}"
                            aria-controls="${this.id}">
                            <a class="more-info">Se ${this.expanded ? "færre" : "flere"} detaljer om måling<span class="icon-right glyphicon glyphicon-menu-${this.expanded ? "up" : "down"}"></span></a>
                        </button>
                    </div>
                </div>
                <p class="maaling-link"><a href="${this.maalingUrl}"><span
                            class="icon border-icon glyphicon glyphicon-chevron-right"></span>Gå til måling</a></p>
            </div>
            <div id="${this.id}" ?hidden=${!this.expanded} class="accordion-content">
                <slot></slot>
            </div>
        `;
    }

    toggleAccordion() {
        this.expanded = !this.expanded;
    }
}